import { FC } from "react";
import styles from "./ui-general-loader.module.css";
import { ASSETS_URL } from "@commons-monorepo/constants";

interface UiGeneralLoaderProps {
  show: boolean;
  text?: string;
}

const UiGeneralLoader: FC<UiGeneralLoaderProps> = ({ text, show }) => {
  return show ?
  <div className={styles.loaderWrapper}>
      <div className={styles.overlay} />
      <div className={styles.progress}>
        <img
        src={`${ASSETS_URL}/prod/web/loader.webp`}
        alt='Loader progress'
        className={styles.img} />

        <div className={styles.logo}>
          <span className={"icon-isotipo-sumer"} />
        </div>
        <div className={styles.text}>{text}</div>
      </div>
    </div> :
  null;
};

export default UiGeneralLoader;